import React, { createContext, useContext, useEffect, useState } from 'react';

import apiOffers from 'api/offers';

// The money of an offer comes from the country of its department: SEK in Sweden, else €
export const getCurrency = (country?: null | string): string =>
  country === 'SE' ? 'SEK' : '€';

const CurrencyContext = createContext('€');

export const useCurrency = (): string => useContext(CurrencyContext);

// The currency of the calculation window of a position of the offer or additional offer
export const OfferCurrencyProvider = ({
  additionalOfferId,
  children,
  offerId,
}: {
  additionalOfferId?: null | number;
  children: React.ReactNode;
  offerId?: null | number;
}): JSX.Element => {
  const [currency, setCurrency] = useState('€');

  useEffect(() => {
    let cancelled = false;
    let load: null | Promise<{
      organizationUnit: null | { country?: null | string };
    }> = null;
    if (additionalOfferId != null) {
      load = apiOffers.additionalOffers.get(additionalOfferId);
    } else if (offerId != null) {
      load = apiOffers.getOffer(offerId);
    }
    if (load !== null) {
      load
        .then((offer) => {
          if (!cancelled) {
            setCurrency(getCurrency(offer?.organizationUnit?.country));
          }
        })
        .catch((error) => console.log(error));
    }

    return () => {
      cancelled = true;
    };
  }, [additionalOfferId, offerId]);

  return (
    <CurrencyContext.Provider value={currency}>
      {children}
    </CurrencyContext.Provider>
  );
};
